import { Component, OnInit, Input } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { AmorphicService } from '../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { Controller } from '../../../Controller';
import { CoverpathUtils } from '../../../../../../coverpath-common/js/static/CoverpathUtils';
import { QuickQuoteService } from '../../../services/quote/quick-quote.service';
import { AuthenticationService } from '../../../../../../coverpath-common/angular/services/authentication/authentication.service';
import { WindowService } from '../../../../../../common/angular-shared/services/window/window.service';
import { BaseQuote } from '../../../../../../common/js/quote/BaseQuote';

@Component({
  moduleId: module.id,
  selector: 'cp-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {
  controller: Controller;
  showHamburger: boolean;
  routeIsHome: boolean;
  routeIsFaq: boolean;
  routeIsSignComplete: boolean;
  routeIsHelp: boolean;
  routeIsAcknowledgement: boolean;
  isTerm: boolean = true;
  isWhole: boolean = false;
  isART: boolean = false;
  nbDecommissionPost30Days: boolean;

  constructor(
    private amorphicService: AmorphicService,
    private router: Router,
    private location: Location,
    private quickQuoteService: QuickQuoteService,
    private windowService: WindowService,
    private activatedRoute: ActivatedRoute,
    private authenticationService: AuthenticationService
  ) {
    this.controller = amorphicService.controller as Controller;
    this.showHamburger = false;
  }

  ngOnInit(): void {
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd && this.location.path() !== '') {
        this.routeIsHome = this.router.url.includes('home');
        this.routeIsFaq = this.router.url.includes('faq');
        this.routeIsSignComplete = this.router.url.includes('sign-complete');
        this.routeIsHelp = this.router.url.includes('help');
        this.routeIsAcknowledgement = this.router.url.includes('acknowledgement');
      }
    });

    this.quickQuoteService.triggerQuickQuoteLoad.subscribe(() => {
      const quote: BaseQuote = this.quickQuoteService.getCurrentQuote();
      if (quote) {
        if (quote.productType === 'Whole') {
          this.isWhole = true;
          this.isTerm = false;
        } else if (quote.term === 1) {
          this.isART = true;
        }
      }
    });
    this.nbDecommissionPost30Days = this.controller.nbDecommissionPost30Days;
  }

  hideHamburger(): void {
    this.showHamburger = false;
  }

  toggleHamburger(): void {
    this.showHamburger = !this.showHamburger;
  }

  doesQuickQuoteExist(): boolean {
    return CoverpathUtils.doesQuickQuoteExist();
  }

  scrollToQuickQuote(): void {
    CoverpathUtils.scrollToElement('quick-quote');
  }

  login(): void {
    this.authenticationService.goToLogin();
  }

  logout(): void {
    this.authenticationService.logout();
  }
}
